import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import DialogComponent from '../../component/dialog/dialog.component';
import DeleteGroupDetail from './delete-group-detail';
import DeleteRestaurantDetail from './delete-restaurant-detail';
import { DeletedResourceState, SelectType } from './deleted-resource-state';
import ResellerAccount from '../reseller/reseller-account.page';
import { ResellerAccountState } from '../reseller/reseller-account-state';

/**
 * 资源回收站详情弹窗
 */
const DeletedDetailDialog = observer((props: {
    // 表格弹窗配置
    dialogConfigData: DeleteDialogProps,
    // 使用数据管理
    useDeleteData: DeletedResourceState
}) => {

    // 弹窗配置参数
    const { dialogType, openDialog, selectId, belonged_group, onCloseDialog } = props.dialogConfigData;

    React.useEffect(() => {

        return () => {

        }
    }, [selectId, belonged_group, openDialog])

    // 渲染相应的组件
    const renderDetailComponent = (comType: SelectType): React.ReactNode => {
        // 经销商账号数据管理
        const useResellerAccountData = new ResellerAccountState({
            belongedResellerId: selectId
        });
        switch (comType) {
            // 集团详情组件
            case 'group': {
                return (
                    <DeleteGroupDetail
                        {...{
                            selectId,
                            belonged_group
                        }}
                    />
                )
            }
            // 餐厅详情组件
            case 'restaurant': {
                return (
                    /* 餐厅信息弹窗 */
                    <DeleteRestaurantDetail
                        {...{
                            selectId,
                            belonged_group
                        }}
                    />
                )
            }
            // 经销商详情组件
            case 'reseller': {
                return (
                    <ResellerAccount
                        componentSource='RECYCLE'
                        useResellerAccountMobx={useResellerAccountData}
                    />
                )
            }
            default: {
                return (
                    <DeleteGroupDetail
                        {...{
                            selectId,
                            belonged_group
                        }}
                    />
                )
            }
        }
    }

    // *********************
    // Render View
    // *********************

    return (
        <Box>
            <DialogComponent
                fullWidth
                maxWidth={'xl'}
                heightSize={'large'}
                open={openDialog ?? false}
                defaultHeaderProps={{
                    onClose: () => {
                        // 关闭弹窗
                        onCloseDialog && onCloseDialog();
                    },
                }}
                onClose={() => {
                    // 关闭弹窗
                    onCloseDialog && onCloseDialog();
                }}
                footer={<></>}
            >
                <Box className={'deleteResource-dialog-content'}>
                    {renderDetailComponent(dialogType)}
                </Box>
            </DialogComponent>
        </Box>
    )
});

export default DeletedDetailDialog;

// 弹窗属性provider
type DeleteDialogProps = {
    // 弹窗显示内容类型  集团 | 餐厅 | 账号
    dialogType: SelectType;
    // 弹窗显示控制
    openDialog?: boolean;
    // 弹窗关闭
    onCloseDialog?: () => void;
    // 选择的列表行id
    selectId: string;
    // 所属集团
    belonged_group?: string;
}